import { AiOutlineInfo } from "react-icons/ai";
import Button from "../../../../atoms/Button";
import CardHeader from "../../../../atoms/CardHeader";
import Breadcrumb from "../../../../molecules/Breadcrumb";
import useModal from "../../../../../hooks/useModal";
import Modal from "../../../../molecules/Modal";
import InfoEmpresa from "../../../../templates/clientes/InfoEmpresa";

const DecideHeader = ({ empresa }) => {
    const { open: openInfo, close, isOpen } = useModal();

    return(
        <CardHeader>
            <Breadcrumb
                items={[
                    { label: "Inicio", to: `/dashboard` },
                    { label: `${empresa?.name || "cargando..."}`, to: `/clientes/empresas/${empresa?.id}/decide` },
                ]}
            />
            <Button
                text={<AiOutlineInfo size={22} />}
                bgColor="black"
                width="w-10"
                onClick={openInfo}
            />
            {isOpen && empresa &&
                <Modal title="Información" onClose={close}>
                    <InfoEmpresa empresa={empresa} />
                </Modal>
            }
        </CardHeader>
    );
}

export default DecideHeader;